export enum CashoutSubmitStatus {
	NONE = 'NONE',
	CONFIRMATION = 'CONFIRMATION',
	SUBMITTING = 'SUBMITTING',
	SUCCESS = 'SUCCESS',
	NEW_OFFER = 'NEW_OFFER',
	ERROR = 'ERROR'
}

export type CashoutInformation = {
	betId: number;
	submitStatus?: CashoutSubmitStatus;
	amount: number;
	newOfferAmount?: number;
};
